<template>
	<div>
        <div class="Rectangle-12-Copy-3">
                <slot name="Orows" v-for="row in rows" :row="row"></slot>
        </div>
	</div>
</template>

<script>
export default {
	name: 'app-table-disenar-escala-orange',
	props: {
		// puesto: String,
		rows: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
    .Rectangle-12-Copy-3 {
        width: 100%;
        max-width: 1032px;
        height: 35px;
        margin: 8px auto 6px;
        padding: 6px 10px 5px 35px;
        border-radius: 9px;
        background-color: #f09c2b;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    span {
        width: 134px;
        height: 14px;
        font-family: NeuzeitGroTBold;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #fff;
    }
    .Orange-Puesto-elemento {
        width: 350px;
        text-transform: lowercase;
        text-align: center;
        height: auto;
    }
    .Orange-Puesto-elemento:nth-child(1) {
        text-align: left;
    }
    .Orange-Puesto-elemento:first-letter {
        text-transform: uppercase;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/table-disenar-escala/app-table-disenar-escala-orange.vue